import React from 'react';
const countries = ['Argentina', 'Mexico', 'Colombia', 'Chile', 'Peru', 'Uruguay', 'Venezuela'];
export function SocialProofBar() {
  return <section className="w-full bg-sage/5 px-5 py-10" data-id="element-166" data-mp="2erz92n04tsy5">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-167" data-mp="29txmvt7etdig">
        <p className="text-sm font-medium text-slate sm:text-base" data-id="element-168" data-mp="25suaxhshg1mi">
          <span className="tracking-tight text-vibrant-green" data-id="element-169" data-mp="25uouaro3vloh">⭐⭐⭐⭐⭐</span> 4.9/5 · Trusted by 500+ nutrition professionals worldwide
        </p>
        
      </div>
    </section>;
}